import { Button, Col, Container, Row } from "react-bootstrap";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";
import { useNavigate } from "react-router-dom";

const NFeCadastroFinalidadeView = () => {
  const navigate = useNavigate();

  const finalidadeSelecionado = () =>
    getLocal<NFeDto>(STORAGENFE_KEY)?.finalidadeEmissao ?? 0;

  const selecionado = finalidadeSelecionado() != undefined;

  const handleNext = (finalidadeEmissao: number) => () => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      finalidadeEmissao: finalidadeEmissao,
    });
    handleProximo(finalidadeEmissao);
  };

  const handleVoltar = () => () => {
    navigate("../operacao");
  };

  const handleProximo = (finalidade: number) => {
    if (finalidade === 4) {
      navigate("../referencia");
      return;
    }
    navigate("../tributacao");
  };

  const buttonVariant = (finalidade: number) => {
    const selecionado = finalidadeSelecionado();

    if (selecionado === undefined || selecionado === finalidade) {
      return "primary";
    }

    return "outline-primary";
  };

  return (
    <>
      <Row>
        <Col xs={12} className="d-grid mt-3">
          <Button
            type="submit"
            onClick={handleNext(1)}
            variant={buttonVariant(1)}
          >
            1-Normal
          </Button>
          <Button
            type="submit"
            onClick={handleNext(4)}
            variant={buttonVariant(4)}
          >
            4-Devolução de mercadoria
          </Button>
        </Col>
      </Row>
      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={!selecionado ? 12 : 6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar()}>
                Voltar
              </Button>
            </Col>
            {selecionado && (
              <Col xs={6} className="d-grid">
                <Button
                  variant="outline-primary"
                  type="submit"
                  onClick={() => handleProximo(finalidadeSelecionado())}
                >
                  Próximo
                </Button>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};
export default NFeCadastroFinalidadeView;
